import React from 'react'

const Main = () => {
  return (
    <div>
      <div id="box2">
            <a href="/"><b>
                    <font size="4"> Sarkari Result Android Apps</font>
                </b></a> || <a href="/"><b>
                    <font size="4">Sarkari Result Windows Apps</font>
                </b></a> || <a href="/"><b>
                    <font size="4">Sarkari Result Apple/IOS
                        Apps</font>
                </b></a>||<a href="/"><b>
                    <font size="4">Follow on Twitter</font>
                </b></a><br/>
            <marquee behavior="alternate" direction="left" onmouseover="stop()" onmouseleave="start()" scrollamount="8">
                <a href="/"><b>
                        <font size="3"> BHU CHS Online Form 2020</font>
                    </b></a>||
                <a href="/"><b>
                        <font size="3"> SSC CPO SI Result 2020</font>
                    </b></a>||
                <a href="/"><b>
                        <font size="3"> SSC Selection Post Vill Result 2020</font>
                    </b></a>
            </marquee> <br/>
            <marquee behavior="alternate" scrollamount="8" onmouseover="stop()" onmouseleave="start()"
                direction="right">
                <a href="/"><b>
                        <font size="3"> SSC CHSL 2018 Tiar || Result 2020</font>
                    </b></a>||
                <a href="/"><b>
                        <font size="3"> IIT JAM Answer Key 2020</font>
                    </b></a>||
                <a href="/"><b>
                        <font size="3"> UPPSC Pre Result 2020</font>
                    </b></a>
            </marquee> <br/>
            <marquee behavior="alternate" scrollamount="8" onmouseover="stop()" onmouseleave="start()" direction="left">
                <a href="/"><b>
                        <font size="3"> LIC AAO/AE Online Form 2020</font>
                    </b></a>||
                <a href="/"><b>
                        <font size="3"> CGPSC Pre Answer Key 2020</font>
                    </b></a>||
                <a href="/"><b>
                        <font size="3"> SSC JIIT 2018 Final Result 2020</font>
                    </b></a>
            </marquee> <br/>
        </div>
        <div id="box3">
            <div style={{backgroundColor: "rgb(151, 151, 12)"}} class="box3">Ordinary Factory <br/> Apply Online</div>
            <div style={{backgroundColor: "blue"}} class=" box3">SSC CGL Tier I <br/> Admit Card</div>
            <div style={{backgroundColor: "orange"}} class="box3">UPSC IAS / IES <br/> Apply Online</div>
            <div style={{backgroundColor: "brown"}} class="box3">CTET July 2020 <br/> Apply Online</div>
            <div style={{backgroundColor: "red"}} class="box3">Navy SSR/AA <br/> Admit Card</div>
            <div style={{backgroundColor: "green"}} class="box3">Coast Guard Navik <br/> Apply Online</div>
            <div style={{backgroundColor: "rgb(241, 22, 176)"}} class="box3">UPSC NDA | 2020 <br/> Apply Online</div>
            <div style={{backgroundColor: "rgb(25, 132, 219)"}} class="box3">MP Primary TET <br/> Apply ONLINE</div>
        </div>
        <div id="box4">
            <div class="box4">
                <div class="box41">Result</div>
                <div class="box42">
                    <ul>
                        <a href="/">
                            <li>Lorem ipsum dolor sit amet.</li>
                        </a>
                        <a href="/">
                            <li>Lorem ipsum dolor sit Lorem, ipsum. amet.</li>
                        </a>
                        <a href="/">
                            <li>Lorem ipsum dolor sit amet.</li>
                        </a>
                        <a href="/">
                            <li>Lorem ipsum dolor Lorem, ipsum. sit amet.</li>
                        </a>
                        <a href="/">
                            <li>Lorem ipsum dolor sit amet.</li>
                        </a>
                        <a href="/">
                            <li>Lorem ipsum dolor sit amet.</li>
                        </a>
                        <a href="/">
                            <li>Lorem ipsum dolor sit amet.</li>
                        </a>
                        <a href="/">
                            <li>Lorem ipsum dolor sit Lorem, ipsum. amet.</li>
                        </a>

                    </ul>
                </div>
            </div>
            <div class="box4">
                <div class="box41">Admit Card</div>
                <div class="box42">
                    <ul>
                        <a href="/">
                            <li>Lorem ipsum dolor sit amet.</li>
                        </a>
                        <a href="/">
                            <li>Lorem ipsum dolor sit Lorem, ipsum. amet.</li>
                        </a>
                        <a href="/">
                            <li>Lorem ipsum dolor sit amet.</li>
                        </a>
                        <a href="/">
                            <li>Lorem ipsum dolor Lorem, ipsum. sit amet.</li>
                        </a>
                        <a href="/">
                            <li>Lorem ipsum dolor sit amet.</li>
                        </a>
                        <a href="/">
                            <li>Lorem ipsum dolor sit amet.</li>
                        </a>
                        <a href="/">
                            <li>Lorem ipsum dolor sit amet.</li>
                        </a>
                        <a href="/">
                            <li>Lorem ipsum dolor sit Lorem, ipsum. amet.</li>
                        </a>

                    </ul>
                </div>
            </div>
            <div class="box4">
                <div class="box41">Latest Jobs</div>
                <div class="box42">
                    <ul>
                        <a href="/">
                            <li>Lorem ipsum dolor sit amet.</li>
                        </a>
                        <a href="/">
                            <li>Lorem ipsum dolor sit Lorem, ipsum. amet.</li>
                        </a>
                        <a href="/">
                            <li>Lorem ipsum dolor sit amet.</li>
                        </a>
                        <a href="/">
                            <li>Lorem ipsum dolor Lorem, ipsum. sit amet.</li>
                        </a>
                        <a href="/">
                            <li>Lorem ipsum dolor sit amet.</li>
                        </a>
                        <a href="/">
                            <li>Lorem ipsum dolor sit amet.</li>
                        </a>
                        <a href="/">
                            <li>Lorem ipsum dolor sit amet.</li>
                        </a>
                        <a href="/">
                            <li>Lorem ipsum dolor sit Lorem, ipsum. amet.</li>
                        </a>

                    </ul>
                </div>
            </div>
        </div>
        <div id="box5">
            <div class="box5">What Can Sarkari result Do to Help Me?</div>
            <div class="box51">
                <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Alias earum ipsum velit perferendis
                    officia perspiciatis obcaecati, dolorum recusandae totam fugiat!</p>
                <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Alias earum ipsum velit Lorem ipsum
                    dolor sit amet, consectetur adipat!</p>
                <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Alias earum ipsum velit perferendis
                    officia persatur molestiae, corporis maiores doloribus!</p>
            </div>
        </div>
        <div id="box6">
            <div class="box5">Why trust SarkariResult.com for Sarkari Result?</div>
            <div class="box6">
                <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Alias earum ipsum velit Lorem ipsum
                    dolor sit amet, consectetur adipisicing elit. In, nulla. perferendis officia perspiciatis
                    obcaecati, dolorum recusandae totam fugiat!</p>
                <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Alias earum ipsum velit perferendis
                    officia perspiciatis obcaecati, dolorum recusandae totam fugiat! Lorem ipsum dolor, sit amet
                    consectetur adipisicing elit. Eveniet quae pariatur molestiae, corporis maiores doloribus!</p>
            </div>
        </div>
    </div>
  )
}

export default Main
